import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { FormGroup, Label, Input, Button, Spinner } from 'reactstrap';
import { deactiveRoute, subtractBusiness, subtractCost, subtractHome } from '../actions';
import FileDropzone from './DropZone';

function TrashIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
  );
}

class CardRoutes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phone: '',
      size: '',
      deliveryDate: '',
      submitted: false,
      loading: false,
      error: null,
      showOptional: false
    };
    this.continueToProduct = this.continueToProduct.bind(this);
    this.removeRoute = this.removeRoute.bind(this);
  }

  continueToProduct() {
    const cfg = typeof window !== 'undefined' ? window.PinkHippoNextEddm : null;
    const activeRoutes = this.props.routes.filter(route => route.active);

    if (!activeRoutes.length) {
      alert('Select at least one route on the map.');
      return;
    }

    if (!cfg || !cfg.restUrl || !cfg.nonce) {
      alert('EDDM checkout is not configured on this page. Add the map using the pink_hippo_eddm_map shortcode.');
      return;
    }

    const total = this.props.excludedBusiness
      ? this.props.homes
      : this.props.homes + this.props.business;
    const perAddress =
      cfg &&
      typeof cfg.postagePerAddress === 'number' &&
      !Number.isNaN(cfg.postagePerAddress)
        ? cfg.postagePerAddress
        : 0.22;
    const costNum = (total * perAddress).toFixed(2);

    const payload = {
      total,
      cost: costNum,
      routes: activeRoutes.map(route => ({
        crid: String(route.attributes.CRID_ID),
        zip: String(route.attributes.ZIP_CODE)
      })),
      name: this.state.name || undefined,
      email: this.state.email || undefined,
      phone: this.state.phone || undefined,
      notes: this.state.size || undefined,
      delivery_date: this.state.deliveryDate || undefined
    };

    this.setState({ loading: true, error: null });

    axios
      .post(cfg.restUrl, payload, {
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': cfg.nonce
        },
        withCredentials: true
      })
      .then((res) => {
        const dest = res.data && res.data.redirect ? res.data.redirect : null;
        if (dest) {
          window.location.href = dest;
          return;
        }
        this.setState({
          loading: false,
          error: 'Unexpected response from server.'
        });
      })
      .catch((err) => {
        const msg =
          (err.response &&
            err.response.data &&
            (err.response.data.message || err.response.data.code)) ||
          err.message ||
          'Request failed';
        console.error('EDDM save failed', err);
        this.setState({ loading: false, error: String(msg) });
      });
  }

  removeRoute(route) {
    this.props.disableRoute(route.attributes.ZIP_CRID);
    this.props.subtractCost(route.attributes.TOT_CNT);
    this.props.subtractHome(route.attributes.RES_CNT);
    this.props.subtractBusiness(route.attributes.BUS_CNT);
  }

  render() {
    const {
      routes,
      homes,
      business,
      excludedBusiness,
      handleExcludedBusiness
    } = this.props;
    const selectedRoutes = routes.filter(route => route.active);
    const displayBusiness = excludedBusiness ? 0 : business;
    const displayTotal = excludedBusiness ? homes : homes + business;

    if (this.state.loading) {
      return (
        <div className="eddm-order-card text-center py-5">
          <Spinner color="dark" className="mb-2">
            Loading...
          </Spinner>
          <p className="small text-muted mb-0">Saving your selection…</p>
        </div>
      );
    }

    if (this.state.submitted) {
      return (
        <div className="eddm-order-card text-center py-4">
          <p className="mb-0 text-success small">Redirecting to the product page…</p>
        </div>
      );
    }

    return (
      <div className="eddm-order-panel">
        <div className="eddm-order-card">
          <h2>Order Details</h2>

          <p
            className="small fw-semibold text-uppercase mb-2"
            style={{ letterSpacing: '0.05em', color: '#6b7280', fontSize: '0.7rem' }}
          >
            Selected routes
          </p>
          <ul className="eddm-route-list">
            {selectedRoutes.length === 0 ? (
              <li className="text-muted small fst-italic border-0">Click routes on the map to add them.</li>
            ) : (
              selectedRoutes.map((route, index) => (
                <li key={index}>
                  <span>
                    {route.attributes.ZIP_CODE}-{route.attributes.CRID_ID}
                  </span>
                  <button
                    type="button"
                    className="eddm-route-remove"
                    onClick={() => this.removeRoute(route)}
                    aria-label={`Remove route ${route.attributes.ZIP_CODE}-${route.attributes.CRID_ID}`}
                  >
                    <TrashIcon />
                  </button>
                </li>
              ))
            )}
          </ul>

          <div className="mb-3">
            <p className="eddm-stat">
              Total homes
              <strong>{homes}</strong>
            </p>
            <p className="eddm-stat">
              Total business
              <strong>{displayBusiness}</strong>
            </p>
            <p className="eddm-stat">
              Total
              <strong>{displayTotal}</strong>
            </p>
          </div>

          <FormGroup check className="eddm-exclude-check">
            <Label check className="d-flex align-items-center gap-2">
              <Input type="checkbox" checked={!!excludedBusiness} onChange={handleExcludedBusiness} />
              Excluded business
            </Label>
          </FormGroup>

          {this.state.error ? (
            <div className="alert alert-danger small py-2 mt-2 mb-0" role="alert">
              {this.state.error}
            </div>
          ) : null}

          <Button
            type="button"
            color=""
            className="eddm-btn-continue"
            onClick={this.continueToProduct}
          >
            Continue
          </Button>

          <div className="eddm-optional-block">
            <button
              type="button"
              className="eddm-optional-toggle"
              onClick={() => this.setState((s) => ({ showOptional: !s.showOptional }))}
              aria-expanded={this.state.showOptional}
            >
              {this.state.showOptional ? '− ' : '+ '}
              Optional contact &amp; files (saved with your selection)
            </button>
            {this.state.showOptional ? (
              <div className="eddm-optional-fields">
                <p className="small text-muted mb-3">
                  You can also add your design on the product page after you continue.
                </p>
                <FormGroup className="mb-2">
                  <Label className="small">Name</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={this.state.name}
                    onChange={(e) => this.setState({ name: e.target.value })}
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  <Label className="small">Email</Label>
                  <Input
                    bsSize="sm"
                    type="email"
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  <Label className="small">Phone</Label>
                  <Input
                    bsSize="sm"
                    type="tel"
                    value={this.state.phone}
                    onChange={(e) => this.setState({ phone: e.target.value })}
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  <Label className="small">Notes</Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={this.state.size}
                    onChange={(e) => this.setState({ size: e.target.value })}
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  <Label className="small">Requested delivery date</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={this.state.deliveryDate}
                    onChange={(e) => this.setState({ deliveryDate: e.target.value })}
                  />
                </FormGroup>
                <FileDropzone onFilesSelected={(files) => this.setState({ files })} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

CardRoutes.propTypes = {
  routes: PropTypes.array.isRequired,
  homes: PropTypes.number.isRequired,
  costs: PropTypes.number.isRequired,
  business: PropTypes.number.isRequired,
  excludedBusiness: PropTypes.bool,
  handleExcludedBusiness: PropTypes.func,
  disableRoute: PropTypes.func
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    disableRoute: (route) => dispatch(deactiveRoute(route)),
    subtractHome: (home) => dispatch(subtractHome(home)),
    subtractCost: (cost) => dispatch(subtractCost(cost)),
    subtractBusiness: (business) => dispatch(subtractBusiness(business))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CardRoutes);
